import React from 'react';
import { Link } from 'react-router-dom';
import { useSettings } from '../../context/SettingsContext';

export default function Announcement() {
  const { settings } = useSettings();
  const a = settings.announcement || {};
  if (!a.enabled || !a.text) return null;
  const inner = <span className="text-sm font-medium">{a.text}</span>;
  return (
    <div className="sf-announcement text-center py-2 px-4" style={{ background: a.background || '#fff', color: a.color || '#000' }}>
      {a.link ? (
        <Link to={a.link} className="block">{inner}</Link>
      ) : (
        inner
      )}
    </div>
  );
}
